import React, { useMemo } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "umi";
import { formatPhoneNumber } from "@/utils/utils";
import MoreMenu from "@/components/MoreMenu";

const useUsersTableColumns = ({ configPerm, onUserMenuItemClick }) =>
  useMemo(
    () => [
      {
        title: "Id",
        dataIndex: "userId",
        render: text => {
          let linkTo = null;

          if (configPerm["IdentityService.User"]) {
            linkTo = `/admin/users/view?userId=${text}`;
          }

          if (linkTo === null) {
            return <span>{text.split("-")[0].toUpperCase()}</span>;
          }

          return (
            <span className="span-click">
              <Link to={linkTo}>{text.split("-")[0].toUpperCase()}</Link>
            </span>
          );
        },
      },
      {
        title: "Name",
        dataIndex: "userName",
      },
      {
        title: "Email",
        dataIndex: "email",
      },
      {
        title: "Phone Number",
        dataIndex: "phoneNumber",
        render: (text, record) => <span>{text ? formatPhoneNumber(text, record.phoneExt) : ""}</span>,
      },
      {
        title: "Autosled Verified",
        dataIndex: "isVerified",
        render: (_, record) => <span>{record.isVerified ? "True" : "False"}</span>,
      },
      {
        title: "Roles",
        dataIndex: "roles",
        render: roles => <span>{(roles || []).map(role => role.name).join(", ")}</span>,
      },
      {
        title: "",
        key: "action",
        dataIndex: "action",
        render: (_, record) => (
          <span>
            <MoreMenu
              onItemClick={key => onUserMenuItemClick(key, record)}
              items={[
                {
                  key: "edit",
                  icon: <EditOutlined />,
                  label: "Edit",
                  authority: "IdentityService.User.Edit",
                },
                {
                  key: "delete",
                  icon: <DeleteOutlined />,
                  label: "Delete",
                  authority: "CoreService.AssociateUsers.Delete",
                },
              ]}
            />
          </span>
        ),
      },
    ],
    [configPerm, onUserMenuItemClick],
  );

export default useUsersTableColumns;
